import { Button } from "@mui/material";
import { styled } from "@mui/system";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";

const StyledButton = styled(Button)({
  position: "fixed",
  bottom: "5%",
  left: "2%",
  display: "none",
  color: "black",
  backgroundColor: "white",
  "@media (max-width: 650px)": {
    display: "flex",
    ":hover": {
      backgroundColor: "white",
    },
  },
  zIndex: 1000,
});

/**
 *
 * @param {Function} handleOnClick Calls the onClick prop
 * @returns Category select button for mobile
 */
const CategorySelectMobileButton = ({ handleOnClick }) => {
  return (
    <StyledButton onClick={handleOnClick}>
      <MenuIcon />
    </StyledButton>
  );
};

export default CategorySelectMobileButton;
